import { Suspense } from 'react';
import { CloseButton, Drawer, Portal, Spinner } from '@chakra-ui/react';
import AthleteEffortDetailLazy from './AthleteEffortDetailLazy';
import styles from './AthleteEffortDrawer.module.scss';

interface AthleteEffortDrawerProps {
  /** Atleta selezionato; se null il drawer non ha contenuto da mostrare. */
  athleteId: string | null;
  /** Nome già noto dalla riga (evita il flash "Atleta" durante il load). */
  athleteName?: string | null;
  teamId: string;
  open: boolean;
  /** Chiude il drawer (consuma la history entry — vedi useDetailParam). */
  onClose: () => void;
}

/**
 * Drawer laterale col drill-down "Sforzo" dell'atleta, aperto cliccando una
 * riga nella tabella Sforzo del team invece di navigare a un'altra pagina.
 *
 * Riusa il pattern Drawer del design system (vedi shared/*Drawer): Portal +
 * Backdrop + Positioner + Content. La chiusura passa SEMPRE da `onClose`
 * (freccia interna, X, backdrop, Esc, tasto Indietro del browser) così lo
 * stato resta coerente con l'URL (`useDetailParam`).
 */
export function AthleteEffortDrawer({
  athleteId,
  athleteName,
  teamId,
  open,
  onClose,
}: AthleteEffortDrawerProps) {
  return (
    <Drawer.Root
      open={open}
      size="xl"
      onOpenChange={(e) => {
        if (!e.open) onClose();
      }}
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          {/* w/maxW come prop Chakra (inline) per non dipendere dai @layer:
              robusto anche se in futuro si disattivano i layer delle recipe. */}
          <Drawer.Content
            w={{ base: '96vw', md: '820px' }}
            maxW="820px"
            className={styles.content}
          >
            <Drawer.CloseTrigger asChild zIndex={10}>
              <CloseButton size="sm" onClick={onClose} />
            </Drawer.CloseTrigger>
            <Drawer.Body className={styles.body}>
              {athleteId && (
                <Suspense
                  fallback={
                    <div className={styles.loading}>
                      <Spinner size="md" />
                    </div>
                  }
                >
                  <AthleteEffortDetailLazy
                    athleteId={athleteId}
                    teamId={teamId}
                    athleteName={athleteName ?? undefined}
                    onBack={onClose}
                  />
                </Suspense>
              )}
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}

export default AthleteEffortDrawer;
